export default "__VITE_ASSET__2c1ae161__"